// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__1Qf1o","default":"list_default__2cFgk","compact":"list_compact__ZW2Z9","table":"list_table__1giAF","sorting-icon":"list_sorting-icon__2OrU7"};